import React from "react";
import { IOrganization } from "../../prep-sa-individual-status-report/models/prep-self-assessment-individual-status-report-models";
import { IEpiProps, IinitialState, ILPReviewerData, PlansForPLYear } from "../models/ilp-page-models";
import { ILPPageProvider } from "../reducers/ilp-page-reducers";
import { IlpPlans } from "./ilp-plans";
import { IlpUserInformation } from "./ilp-user-information";

interface IProps {
    epiProps: IEpiProps;
    organizations: Array<IOrganization>;
    userFullName: string;
    selectedOrganization: string;
    plans: Array<PlansForPLYear>;
    customerKey: string;
    nfToken: string;
}

const ILPPageApp = ({ epiProps, organizations, userFullName, selectedOrganization, plans, customerKey, nfToken }: IProps) => {
    const initialState: IinitialState = {
        epiProps: epiProps,
        selectedOrg: selectedOrganization,
        organizations: organizations,
        userFullName: userFullName,
        plans: plans,
        formError: false,
        isLoading: false,
        customerKey: customerKey,
        nfToken: nfToken
    };

    return (
        <ILPPageProvider initialState={initialState}>
            <div className="ilp-page-container">
                <IlpUserInformation />
                <div className="prep-report-header">
                    <h3>{epiProps.headingText}</h3>
                </div>
                <div className="ilp-description rich-text">
                    <p dangerouslySetInnerHTML={{ __html: epiProps.description }} />
                </div>
                <IlpPlans />
            </div>
        </ILPPageProvider>
    )
}

export default ILPPageApp